import React from 'react';
import ReactDOM from 'react-dom/client';
import 'react-day-picker/dist/style.css';
// Polices servies par le portail (plus de Google Fonts) : mêmes graisses que l'ancien <link>.
import '@fontsource/ibm-plex-sans/300.css';
import '@fontsource/ibm-plex-sans/400.css';
import '@fontsource/ibm-plex-sans/500.css';
import '@fontsource/ibm-plex-sans/600.css';
import '@fontsource/ibm-plex-sans/700.css';
import '@fontsource/ibm-plex-mono/400.css';
import '@fontsource/ibm-plex-mono/500.css';
import '@fontsource/ibm-plex-mono/600.css';
import '@fontsource/playwrite-fr-moderne/100.css';
import '@fontsource/playwrite-fr-moderne/200.css';
import '@fontsource/playwrite-fr-moderne/300.css';
import '@fontsource/playwrite-fr-moderne/400.css';
import './index.css';
import App from './App';
import { AuthProvider } from './hooks/useAuth';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <AuthProvider>
    <App />
  </AuthProvider>
);
